export default __webpack_public_path__ + "static/media/author_img.e6ba23e5.jpg";